<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- noticia -->
  <section v-if="noticia != ''" class="ftco-section">
    <div class="container">
      <div class="row" style="align-items: center;">
        <div class="col-lg-12">
          <h2 class="mb-3">{{ noticia.itiNome }}</h2>
          <p v-html="noticia.itiResumo1"></p>
          <p>
            <img style="" :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" class="img-fluid">
          </p>
          <p v-html="noticia.itiResumo2"></p><br>
          
            <button onclick="history.back()" class="btn">Voltar</button>
          
        </div>
      </div>
    </div>
  </section>
  <!-- END noticia -->
</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'BlogDetalheView',
  components: {

  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    noticia: [],

  }),

  methods: {

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Blog - Performance Elevadores - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

  },

  created() {

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/47/blogtopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

      //aqui busca página detalhe
      axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.noticia = response.data;
        this.carregaMetas(this.removerTagsHTML(this.noticia.itiDescricao1), this.noticia.itiNome);
        //console.log('this.noticia')
        //console.log(this.noticia)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>